import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';

export const Heading = styled.h1`
  color: var(--cvna-color-blue-6);
  font-size: 28px;
  font-weight: 700;
  line-height: 35px;
  margin-bottom: 33px;
  text-align: center;

  ${mediaQuery('s')} {
    font-size: 28px;
    margin-bottom: 30px;
  }
`;

export const FinancingDescription = styled.div`
  color: var(--cvna-color-grey-5);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0 auto;
  text-align: center;
  max-width: 854px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  padding-top: 30px;
  justify-content: center;
  cursor: pointer;
  color: var(--cvna-color-blue-2);
  :hover {
    color: var(--cvna-color-blue-3);
  }
`;

export const FinancingFAQLink = styled.a`
  cursor: pointer;
  color: var(--cvna-color-blue-2);
  :hover {
    color: var(--cvna-color-blue-3);
  }
`;
